import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-xl font-bold" }
const _hoisted_2 = { class: "font-bold capitalize" }

import CardTemplate from "@/components/template/CardTemplate.vue"

  interface Details {
    icon: string
    title: string
    visible: boolean
    description: string
  }

  interface Props {
    type: string
    collection: Details[]
    color?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsContainer',
  props: {
    type: null,
    collection: null,
    color: null
  },
  setup(__props: any) {

const props = __props as {
    type: string
    collection: Details[]
    color?: string
  }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardTemplate, { class: "mx-3" }, {
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(__props.type), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.collection, (details) => {
        return (_openBlock(), _createElementBlock("span", {
          key: `${details}_id`,
          class: "flex gap-3 items-center py-2"
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(`${details.icon}`),
            style: _normalizeStyle({ color: `${__props.color}` || '#7442c8' })
          }, null, 6),
          _createTextVNode(" " + _toDisplayString(details.description) + " ", 1),
          _createElementVNode("p", _hoisted_2, _toDisplayString(details.title), 1)
        ]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})